import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getPOAById = id => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.POA + `/by-id/${id}`);
};

export const createPOA = (id, data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.POA + `/${id}`, data);
};

export const deletePOA = (id, contract_id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.POA + `/delete/${id}/${contract_id}`, data);
};